import ExpenseItems from './expenses/ExpenseItems';
import ExpenseSummaryByClientAndProject from './expenses/ExpenseSummaryByClientAndProject';
import ExpenseSummaryByExpenseCategory from './expenses/ExpenseSummaryByExpenseCategory';
import ExpenseSummaryByMember from './expenses/ExpenseSummaryByMember';
import ExpenseSummaryByMemberPractice from './expenses/ExpenseSummaryByMemberPractice';
import ExpenseSummaryByProject from './expenses/ExpenseSummaryByProject';
import ExpenseSummaryByProjectType from './expenses/ExpenseSummaryByProjectType';
import AccountsReceivableAging from './financial/AccountsReceivableAging';
import ClientPurchaseOrders from './financial/ClientPurchaseOrders';
import ClientStatement from './financial/ClientStatement';
import CreditNoteDetail from './financial/CreditNoteDetail';
import CreditNotes from './financial/CreditNotes';
import FixedFeeServicesRevenueByClientAndProject from './financial/FixedFeeServicesRevenueByClientAndProject';
import HourlyRevenueByClientAndProject from './financial/HourlyRevenueByClientAndProject';
import InvoiceDetail from './financial/InvoiceDetail';
import Invoices from './financial/Invoices';
import InvoicesByClient from './financial/InvoicesByClient';
import Payments from './financial/Payments';
import PaymentsByInvoice from './financial/PaymentsByInvoice';
import PerformanceByClient from './financial/PerformanceByClient';
import PerformanceByClientPractice from './financial/PerformanceByClientPractice';
import PerformanceByMember from './financial/PerformanceByMember';
import PerformanceByMemberPractice from './financial/PerformanceByMemberPractice';
import PerformanceByProject from './financial/PerformanceByProject';
import PerformanceByProjectAndMember from './financial/PerformanceByProjectAndMember';
import PerformanceByProjectAndTask from './financial/PerformanceByProjectAndTask';
import PerformanceByProjectPractice from './financial/PerformanceByProjectPractice';
import PerformanceByProjectType from './financial/PerformanceByProjectType';
import ScheduledItems from './financial/ScheduledItems';
import TransactionSummaryByInvoiceItem from './financial/TransactionSummaryByInvoiceItem';
import UninvoicedRevenue from './financial/UninvoicedRevenue';
import HoursPlanByProjectAndResource from './forecast/HoursPlanByProjectAndResource';
import HoursPlanByResourceAndProject from './forecast/HoursPlanByResourceAndProject';
import HoursVarianceByMemberAndProject from './forecast/HoursVarianceByMemberAndProject';
import HoursVarianceByProjectAndResource from './forecast/HoursVarianceByProjectAndResource';
import HoursVarianceByProjectAndRole from './forecast/HoursVarianceByProjectAndRole';
import PerformanceForecastByProject from './forecast/PerformanceForecastByProject';
import PerformanceForecastByProjectByTimeUnit from './forecast/PerformanceForecastByProjectByTimeUnit';
import PerformanceForecastByResourceByTimeUnit from './forecast/PerformanceForecastByResourceByTimeUnit';
import PerformancePlanByProject from './forecast/PerformancePlanByProject';
import PerformancePlanbyResourceByTimeUnit from './forecast/PerformancePlanByResourceByTimeUnit';
import ServicesRevenuePlanByClientAndProject from './forecast/ServicesRevenuePlanByClientAndProject';
import ServicesRevenuePlanByResourceAndProjectAndTimeUnit from './forecast/ServicesRevenuePlanByResourceAndProjectByTimeUnit';
import ServicesRevenueVarianceByMember from './forecast/ServicesRevenueVarianceByMember';
import ServicesRevenueVarianceByProject from './forecast/ServicesRevenueVarianceByProject';
import UtilizationPlanByMember from './forecast/UtilizationPlanByMember';
import UtilizationPlanByMemberPractice from './forecast/UtilizationPlanByMemberPractice';
import UtilizationVarianceByMember from './forecast/UtilizationVarianceByMember';
import OpportunitiesByMonth from './pipeline/OpportunitiesByMonth';
import OpportunityDetail from './pipeline/OpportunityDetail';
import ProjectTimeStatement from './time/ProjectTimeStatement';
import TimeApprovalSummaryByMember from './time/TimeApprovalSummaryByMember';
import TimeAttachments from './time/TimeAttachments';
import TimeClientApprovalSummaryByMember from './time/TimeClientApprovalSummaryByMember';
import TimeEntries from './time/TimeEntries';
import TimeEntriesPendingApproval from './time/TimeEntriesPendingApproval';
import TimeOffByMember from './time/TimeOffByMember';
import Timesheets from './time/Timesheets';
import TimeSummaryByClient from './time/TimeSummaryByClient';
import TimeSummaryByClientAndMember from './time/TimeSummaryByClientAndMember';
import TimeSummaryByClientAndProject from './time/TimeSummaryByClientAndProject';
import TimeSummaryByClientByTimeUnit from './time/TimeSummaryByClientByTimeUnit';
import TimeSummaryByMember from './time/TimeSummaryByMember';
import TimeSummaryByMemberAndClient from './time/TimeSummaryByMemberAndClient';
import TimeSummaryByMemberAndProject from './time/TimeSummaryByMemberAndProject';
import TimeSummaryByMemberAndProjectAndTask from './time/TimeSummaryByMemberAndProjectAndTask';
import TimeSummaryByMemberByTimeUnit from './time/TimeSummaryByMemberByTimeUnit';
import TimeSummaryByMemberPractice from './time/TimeSummaryByMemberPractice';
import TimeSummaryByProject from './time/TimeSummaryByProject';
import TimeSummaryByProjectAndMember from './time/TimeSummaryByProjectAndMember';
import TimeSummaryByProjectAndMemberAndTask from './time/TimeSummaryByProjectAndMemberAndTask';
import TimeSummaryByProjectAndRole from './time/TimeSummaryByProjectAndRole';
import TimeSummaryByProjectAndRoleAndTask from './time/TimeSummaryByProjectAndRoleAndTask';
import TimeSummaryByProjectAndTask from './time/TimeSummaryByProjectAndTask';
import TimeSummaryByProjectByTimeUnit from './time/TimeSummaryByProjectByTimeUnit';
import TimeSummaryByProjectType from './time/TimeSummaryByProjectType';
import TimeSummaryByTaskAndRoleAndMemberByTimeUnit from './time/TimeSummaryByTaskAndRoleAndMemberByTimeUnit';
import UnsubmittedTimesheets from './time/UnsubmittedTimesheets';
import UtilizationByMember from './utilization/UtilizationByMember';
import UtilizationByMemberPractice from './utilization/UtilizationByMemberPractice';
import UtilizationByTimeUnit from './utilization/UtilizationByTimeUnit';
import ClientContacts from './workspace/ClientContacts';
import Clients from './workspace/Clients';
import History from './workspace/History';
import Members from './workspace/Members';
import ProjectHealthByProject from './workspace/ProjectHealthByProject';
import ProjectMembers from './workspace/ProjectMembers';
import Projects from './workspace/Projects';
import ProjectRoles from './workspace/ProjectRoles';
import ProjectTasks from './workspace/ProjectTasks';

const templates = {
  // Forecast
  performance_forecast_by_project: { component: PerformanceForecastByProject, section: 'forecast' },
  performance_forecast_by_project_by_time_unit: {
    component: PerformanceForecastByProjectByTimeUnit,
    section: 'forecast',
  },
  performance_forecast_by_resource_by_time_unit: {
    component: PerformanceForecastByResourceByTimeUnit,
    section: 'forecast',
  },

  // Plan
  hours_plan_by_project_and_resource: { component: HoursPlanByProjectAndResource, section: 'plan' },
  hours_plan_by_resource_and_project: { component: HoursPlanByResourceAndProject, section: 'plan' },
  performance_plan_by_project: { component: PerformancePlanByProject, section: 'plan' },
  services_revenue_plan_by_client_and_project: { component: ServicesRevenuePlanByClientAndProject, section: 'plan' },
  performance_plan_by_resource_by_time_unit: { component: PerformancePlanbyResourceByTimeUnit, section: 'plan' },
  utilization_plan_by_member: { component: UtilizationPlanByMember, section: 'plan' },
  utilization_plan_by_member_practice: { component: UtilizationPlanByMemberPractice, section: 'plan' },
  services_revenue_plan_by_resource_and_project_by_time_unit: {
    component: ServicesRevenuePlanByResourceAndProjectAndTimeUnit,
    section: 'plan',
  },

  // Variance
  hours_variance_by_member_and_project: { component: HoursVarianceByMemberAndProject, section: 'variance' },
  hours_variance_by_project_and_resource: { component: HoursVarianceByProjectAndResource, section: 'variance' },
  hours_variance_by_project_and_role: { component: HoursVarianceByProjectAndRole, section: 'variance' },
  utilization_variance_by_member: { component: UtilizationVarianceByMember, section: 'variance' },

  services_revenue_variance_by_project: { component: ServicesRevenueVarianceByProject, section: 'variance' },
  services_revenue_variance_by_member: { component: ServicesRevenueVarianceByMember, section: 'variance' },

  // Time
  project_time_statement: { component: ProjectTimeStatement, section: 'time' },
  time_approval_summary_by_member: { component: TimeApprovalSummaryByMember, section: 'time' },
  time_attachments: { component: TimeAttachments, section: 'time' },
  time_client_approval_summary_by_member: { component: TimeClientApprovalSummaryByMember, section: 'time' },
  time_entries: { component: TimeEntries, section: 'time' },
  time_entries_pending_approval: { component: TimeEntriesPendingApproval, section: 'time' },
  time_off_by_member: { component: TimeOffByMember, section: 'time' },
  timesheets: { component: Timesheets, section: 'time' },
  time_summary_by_client: { component: TimeSummaryByClient, section: 'time' },
  time_summary_by_client_and_member: { component: TimeSummaryByClientAndMember, section: 'time' },
  time_summary_by_client_and_project: { component: TimeSummaryByClientAndProject, section: 'time' },
  time_summary_by_client_by_time_unit: { component: TimeSummaryByClientByTimeUnit, section: 'time' },
  time_summary_by_member: { component: TimeSummaryByMember, section: 'time' },
  time_summary_by_member_and_client: { component: TimeSummaryByMemberAndClient, section: 'time' },
  time_summary_by_member_and_project: { component: TimeSummaryByMemberAndProject, section: 'time' },
  time_summary_by_member_and_project_and_task: { component: TimeSummaryByMemberAndProjectAndTask, section: 'time' },
  time_summary_by_member_by_time_unit: { component: TimeSummaryByMemberByTimeUnit, section: 'time' },
  time_summary_by_member_practice: { component: TimeSummaryByMemberPractice, section: 'time' },
  time_summary_by_project: { component: TimeSummaryByProject, section: 'time' },
  time_summary_by_project_and_member: { component: TimeSummaryByProjectAndMember, section: 'time' },
  time_summary_by_project_and_member_and_task: { component: TimeSummaryByProjectAndMemberAndTask, section: 'time' },
  time_summary_by_project_and_role: { component: TimeSummaryByProjectAndRole, section: 'time' },
  time_summary_by_project_and_role_and_task: { component: TimeSummaryByProjectAndRoleAndTask, section: 'time' },
  time_summary_by_project_and_task: { component: TimeSummaryByProjectAndTask, section: 'time' },
  time_summary_by_project_by_time_unit: { component: TimeSummaryByProjectByTimeUnit, section: 'time' },
  time_summary_by_project_type: { component: TimeSummaryByProjectType, section: 'time' },
  time_summary_by_task_and_role_and_member_by_time_unit: {
    component: TimeSummaryByTaskAndRoleAndMemberByTimeUnit,
    section: 'time',
  },
  unsubmitted_timesheets: { component: UnsubmittedTimesheets, section: 'time' },

  // Accounting
  accounts_receivable_aging: { component: AccountsReceivableAging, section: 'accounting' },
  client_purchase_orders: { component: ClientPurchaseOrders, section: 'accounting' },
  client_statement: { component: ClientStatement, section: 'accounting' },
  credit_notes: { component: CreditNotes, section: 'accounting' },
  credit_note_detail: { component: CreditNoteDetail, section: 'accounting' },
  fixed_fee_services_revenue_by_client_and_project: {
    component: FixedFeeServicesRevenueByClientAndProject,
    section: 'accounting',
  },
  hourly_revenue_by_client_and_project: { component: HourlyRevenueByClientAndProject, section: 'accounting' },
  invoice_detail: { component: InvoiceDetail, section: 'accounting' },
  invoices: { component: Invoices, section: 'accounting' },
  invoices_by_client: { component: InvoicesByClient, section: 'accounting' },
  payments: { component: Payments, section: 'accounting' },
  payments_by_invoice: { component: PaymentsByInvoice, section: 'accounting' },
  scheduled_items: { component: ScheduledItems, section: 'accounting' },
  transaction_summary_by_invoice_item: { component: TransactionSummaryByInvoiceItem, section: 'accounting' },
  uninvoiced_revenue: { component: UninvoicedRevenue, section: 'accounting' },

  // Performance
  performance_by_client: { component: PerformanceByClient, section: 'performance' },
  performance_by_client_practice: { component: PerformanceByClientPractice, section: 'performance' },
  performance_by_member: { component: PerformanceByMember, section: 'performance' },
  performance_by_member_practice: { component: PerformanceByMemberPractice, section: 'performance' },
  performance_by_project: { component: PerformanceByProject, section: 'performance' },
  performance_by_project_and_member: { component: PerformanceByProjectAndMember, section: 'performance' },
  performance_by_project_and_task: { component: PerformanceByProjectAndTask, section: 'performance' },
  performance_by_project_practice: { component: PerformanceByProjectPractice, section: 'performance' },
  performance_by_project_type: { component: PerformanceByProjectType, section: 'performance' },

  // Pipeline
  opportunity_detail: { component: OpportunityDetail, section: 'pipeline' },
  opportunities_by_month: { component: OpportunitiesByMonth, section: 'pipeline' },

  // Expenses
  expense_items: { component: ExpenseItems, section: 'expenses' },
  expense_summary_by_client_and_project: { component: ExpenseSummaryByClientAndProject, section: 'expenses' },
  expense_summary_by_expense_category: { component: ExpenseSummaryByExpenseCategory, section: 'expenses' },
  expense_summary_by_member: { component: ExpenseSummaryByMember, section: 'expenses' },
  expense_summary_by_member_practice: { component: ExpenseSummaryByMemberPractice, section: 'expenses' },
  expense_summary_by_project: { component: ExpenseSummaryByProject, section: 'expenses' },
  expense_summary_by_project_type: { component: ExpenseSummaryByProjectType, section: 'expenses' },

  // Utilization
  utilization_by_time_unit: { component: UtilizationByTimeUnit, section: 'utilization' },
  utilization_by_member: { component: UtilizationByMember, section: 'utilization' },
  utilization_by_member_practice: { component: UtilizationByMemberPractice, section: 'utilization' },

  // Workspace
  client_contacts: { component: ClientContacts, section: 'workspace' },
  clients: { component: Clients, section: 'workspace' },
  history: { component: History, section: 'workspace' },
  members: { component: Members, section: 'workspace' },
  project_members: { component: ProjectMembers, section: 'workspace' },
  projects: { component: Projects, section: 'workspace' },
  project_roles: { component: ProjectRoles, section: 'workspace' },
  project_tasks: { component: ProjectTasks, section: 'workspace' },
  project_health_by_project: { component: ProjectHealthByProject, section: 'workspace' },
};

export default templates;
